import type { ShiftTemplateSchema } from '@libs/data-access/queries'

export enum DND_TYPE {
  REST = 'rest',
  SHIFT = 'shift',
  FAVORITE_SHIFT = 'favorite_shift',
  FAVORITE_REST = 'favorite_rest',
  NOTE = 'note'
}

export type DND_TYPES_ACCEPT = DND_TYPE | DND_TYPE[]

export enum DND_ACTION {
  COPY = 'copy',
  DUPLICATE = 'duplicate',
  MOVE = 'move',
  DELETE = 'delete'
}

export const DND_ACTIONS_ACL = {
  [DND_ACTION.COPY]: [DND_TYPE.FAVORITE_REST, DND_TYPE.FAVORITE_SHIFT],
  [DND_ACTION.DUPLICATE]: [DND_TYPE.REST, DND_TYPE.SHIFT],
  [DND_ACTION.MOVE]: [DND_TYPE.REST, DND_TYPE.SHIFT],
  [DND_ACTION.DELETE]: [DND_TYPE.FAVORITE_SHIFT, DND_TYPE.SHIFT, DND_TYPE.REST]
}

export const DAY_CELL_ALLOWED_TYPES = [
  DND_TYPE.REST,
  DND_TYPE.SHIFT,
  DND_TYPE.FAVORITE_SHIFT,
  DND_TYPE.FAVORITE_REST
]

export type DragItemType = {
  type: DND_TYPE
  id: number
}

export type SortableDragItemType = {
  type: DND_TYPE
  id: number
  index: number
  data?: ShiftTemplateSchema
}
